import React from 'react'
import Message from './Message'

/* doc
---
title: LightMessage
name: LightMessage
category: React - Bulma
parent: Message
---

A `LightMessage` component applies the `.is-light` class to the `Message` component.

Use this component to display a minimal, non-intrusive message to the user.

See the `Message` documentation for further information.

```html_example
  <LightMessage>
    <MessageHeader>...</MessageHeader>
    <MessageBody>
      ...
    </MessageBody>
  </LightMessage>
```
*/
function LightMessage(props) {
  const { className, children, ...rest } = props

  const classes = [
    'is-light',
    className || '',
  ]

  return (
    <Message {...rest} className={classes.join(' ')}>
      {children}
    </Message>
  )
}

export default LightMessage
